import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'approxBigNumber',
})
export class ApproxBigNumberPipe implements PipeTransform {
  public transform(bigNumber: number): string {
    if (bigNumber < 1000) {
      return `${bigNumber}`;
    } else if (bigNumber < Math.pow(10, 6)) {
      return `${fixedNumber(bigNumber, 3, 0)}K`;
    } else if (bigNumber < Math.pow(10, 9)) {
      return `${fixedNumber(bigNumber, 6, 1)}MM`;
    } else if (bigNumber < Math.pow(10, 12)) {
      return `${fixedNumber(bigNumber, 9, 1)}B`;
    }
  }
}

// If this ends in .0 we are not going to show the decimal
function fixedNumber(number: number, power: number, decimals: number): string {
  const numberString = (number / Math.pow(10, power)).toFixed(decimals);
  return numberString.replace('.0', '');
}
